import request from './request'
const activity = 'ACTIVITY-SERVE'

// 广宣物料维护列表
export function materialfindList(data) {
  return request({
    url: activity + '/material/findList',
    method: 'post',
    data
  })
}
// 广宣物料维护>>新增广宣物料
export function addMaterial(data) {
  return request({
    url: activity + '/material/add',
    method: 'post',
    data,
    headers: {
      contentType: false,
      processData: false,
      dataType: 'json'
    }
  })
}
// 广宣物料维护>>修改广宣物料
export function updateMaterial(data) {
  return request({
    url: activity + '/material/update',
    method: 'post',
    data,
    headers: {
      contentType: false,
      processData: false,
      dataType: 'json'
    }
  })
}
// 广宣物料维护>>导出广宣物料表
export function exportMaterial(data) {
  return request({
    url: activity + '/material/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 广宣物料维护>>导入广宣物料表
export function uploadMaterial(data) {
  return request({
    url: activity + '/material/upload',
    method: 'post',
    data
  })
}
// 通过id查询广宣物料
export function getMaterialById(data) {
  return request({
    url: activity + '/material/findById?id=' + data,
    method: 'get'
  })
}
// 通过id查询广宣物料
export function getMaterialApplyProcessCode() {
  return request({
    url: activity + '/apply-order/getMaterialApplyProcessCode',
    method: 'get'
  })
}

// 获取物料图片
export function getImgs(data) {
  return request({
    url: activity + '/material/getFileByte',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 广宣物料维护>>取消/开通申领
export function cancelApply(data) {
  return request({
    url: activity + '/material/cancelApply',
    method: 'post',
    data
  })
}
// 广宣物料维护>>增加入库
export function updateInMaterial(data) {
  return request({
    url: activity + '/material/insertInWarehouse',
    method: 'post',
    data
  })
}
// 广宣物料维护>>减库操作
export function updateOutMaterial(data) {
  return request({
    url: activity + '/material/insertOutWarehouse',
    method: 'post',
    data
  })
}
// 广宣物料维护>>删除广宣物料
export function deleteMaterial(data) {
  return request({
    url: activity + '/material/delete',
    method: 'post',
    data
  })
}
// 广宣物料入库表查询
export function findInList(data) {
  return request({
    url: activity + '/in-warehouse/findList',
    method: 'post',
    data
  })
}
// 导出广宣物料入库表
export function exportInWarehouse(data) {
  return request({
    url: activity + '/in-warehouse/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 广宣物料出库表查询
export function findOutList(data) {
  return request({
    url: activity + '/out-warehouse/findList',
    method: 'post',
    data
  })
}
// 导出广宣物料出库表
export function exportOutWarehouse(data) {
  return request({
    url: activity + '/out-warehouse/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 按参数修改出库单及申领单物料数量
export function updateOutAndOrder(data) {
  return request({
    url: activity + '/out-warehouse/update',
    method: 'post',
    data
  })
}
// 保存广宣物料申领订单
export function saveApplyOrder(data) {
  return request({
    url: activity + '/apply-order/saveApplyOrder',
    method: 'post',
    data
  })
}
// 提交广宣物料申领订单
export function commitOrder(data) {
  return request({
    url: activity + '/apply-order/commitOrder',
    method: 'post',
    data
  })
}
// 删除广宣物料申领订单
export function deleteApplyOrder(data) {
  return request({
    url: activity + '/apply-order/deleteApplyOrder',
    method: 'post',
    data
  })
}
// 申领订单审核通过
export function approveOrder(data) {
  return request({
    url: activity + '/apply-order/approveOrder',
    method: 'post',
    data
  })
}
// 申领订单驳回
export function rejectOrder(data) {
  return request({
    url: activity + '/apply-order/rejectOrder',
    method: 'post',
    data
  })
}
// 申领订单收货
export function receiveMaterial(data) {
  return request({
    url: activity + '/apply-order/receiveMaterial',
    method: 'post',
    data
  })
}
// 广宣物料申领订单列表
export function findOrderList(data) {
  return request({
    url: activity + '/apply-order/findList',
    method: 'post',
    data
  })
}
// 导出广宣物料申领订单列表
export function exportOrder(data) {
  return request({
    url: activity + '/apply-order/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 申领订单物料保存
export function saveOrderMaterial(data) {
  return request({
    url: activity + '/apply-order/saveOrderMaterial',
    method: 'post',
    data
  })
}

// 申领订单物流号保存
export function saveMaterialOrderLogistics(data) {
  return request({
    url: activity + '/apply-order/saveMaterialOrderLogistics',
    method: 'post',
    data
  })
}

// 根据物料订单id查询物流订单列表
export function findMaterialOrderLogisticsList(data) {
  return request({
    url: activity + '/apply-order/findMaterialOrderLogisticsList?orderId=' + data,
    method: 'get',
  })
}

// 申领订单物料删除
export function deleteOrderMaterial(data) {
  return request({
    url: activity + '/apply-order/deleteOrderMaterial',
    method: 'post',
    data
  })
}
// 物料申请明细表
export function findOrderDetailList(data) {
  return request({
    url: activity + '/material-order-detail/findList',
    method: 'post',
    data
  })
}

// 物料申请明细表 01
export function findList4MaterialApply(data) {
  return request({
    url: activity + '/material-order-detail/findList4MaterialApply',
    method: 'post',
    data
  })
}


// 导出物料申请明细表
export function exportOrderMaterial(data) {
  return request({
    url: activity + '/material-order-detail/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 物料订单明细
export function getOrderById(data) {
  return request({
    url: activity + '/apply-order/getOrderDetail?id=' + data,
    method: 'get'
  })
}
// 通过列表查询物料订单明细，批量审批时使用
export function getOrderByIdList(data) {
  return request({
    url: activity + '/apply-order/getOrderDetailByIds',
    method: 'post',
    data
  })
}

// 收货地址列表
export function getAddressList(data) {
  return request({
    url: activity + '/address/pageList',
    method: 'post',
    data
  })
}

// 收货地址新增
export function addAddressList(data) {
  return request({
    url: activity + '/address/save',
    method: 'post',
    data
  })
}

// 收货地址新增
export function editAddressList(data) {
  return request({
    url: activity + '/address/update',
    method: 'post',
    data
  })
}

// /address/delete
export function deleteAddressList(id) {
  return request({
    url: activity + `/address/delete?id=${id}`,
    method: 'get',
  })
}
export function setDefaultAddress(data) {
  return request({
    url: activity + `/address/updateAddress`,
    method: 'post',
    data
  })
}

//  通过收货人获取详细信息
export function findAddressListByUserNo(data) {
  return request({
    url: activity + `/address/findAddressListByUserNo`,
    method: 'post',
    data
  })
}

//  通过获得所有收货人信息
export function findAddressListAll(data) {
  return request({
    url: activity + `/address/findAddressListAll`,
    method: 'post',
    data
  })
}


export function updataApplyOrder(data) {
  return request({
    url: activity + '/apply-order/updataApplyOrder',
    method: 'post',
    data
  })
}

// 发货批次清单查询
export function findLogisticBatchList(data) {
  return request({
    url: activity + '/apply-order/findLogisticBatchList',
    method: 'post',
    data
  })
}


// 生成发货批次号及服务器上的文件
export function generateBatchFile(data) {
  return request({
    url: activity + '/apply-order/generateBatchFile',
    method: 'post',
    data
  })
}

// 下载发货批次文件
export function getBatchFile(data) {
  return request({
    url: activity + '/apply-order/getBatchFileByte',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 物料申领额度管理
// 查询物料申领额度列表
export function findMaterialApplyQuotaList(data) {
  return request({
    url: activity + '/materialApplyQuota/findList',
    method: 'post',
    data
  })
}

// 通过id查询物料申领额度
export function getMaterialApplyQuotaById(id) {
  return request({
    url: activity + '/materialApplyQuota/findById?id=' + id,
    method: 'get'
  })
}

// 新增物料申领额度
export function addMaterialApplyQuota(data) {
  return request({
    url: activity + '/materialApplyQuota/add',
    method: 'post',
    data
  })
}

// 修改物料申领额度
export function updateMaterialApplyQuota(data) {
  return request({
    url: activity + '/materialApplyQuota/update',
    method: 'post',
    data
  })
}

// 删除物料申领额度
export function deleteMaterialApplyQuota(data) {
  return request({
    url: activity + '/materialApplyQuota/delete',
    method: 'post',
    data
  })
}

// 下载物料申领额度导入模板
export function downloadMaterialApplyQuotaTemplate() {
  return request({
    url: activity + '/materialApplyQuota/downloadTemplate',
    method: 'get',
    responseType: 'blob'
  })
}

// 导出物料申领额度
export function importMaterialApplyQuota(data) {
  return request({
    url: activity + '/materialApplyQuota/import',
    method: 'post',
    data
  })
}

export function exportMaterialApplyQuotaList(data) {
  return request({
    url: activity + '/materialApplyQuota/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
